import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-asc-icon',
  templateUrl: 'asc-icon.component.html'
})
export class AscIconComponent {
  constructor() {}
}
